import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

/* 스텁 모듈은 흐리게 — 시안 opacity-70. */
export const stubStyle = css`
  opacity: 0.7;
`;

export const headStyle = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${theme.space.md}px;
`;

export const nameStyle = css`
  margin: 0;
  font-size: ${theme.fontSize.lg}px;
  font-weight: 600;
  color: ${theme.color.text};
`;

export const descStyle = css`
  margin: ${theme.space.xs}px 0 0;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

export const fieldsStyle = css`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${theme.space.md}px;
  margin-top: ${theme.space.md}px;
  font-size: ${theme.fontSize.md}px;
  color: ${theme.color.text};
`;

export const fieldLabelStyle = css`
  margin-bottom: ${theme.space.xs}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

export const monoStyle = css`
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
`;

export const jsonBlockStyle = css`
  margin-top: ${theme.space.md}px;
`;
